import { Outlet } from 'react-router-dom'

const Contracts = () => {
  return <Outlet />
}

export default Contracts
